import { brandColors } from '@/styles/sunrunTheme.styles';
import { TextEffectCF } from '@/types';

import RainbowSlideVertical from './RainbowSlide';

export const textEffectColorMap: Record<
  NonNullable<TextEffectCF['fields']['colors']>[number],
  string
> = {
  'Charge Blue': brandColors.chargeBlue,
  'Charge Red': brandColors.chargeRed,
  'Charge Yellow': brandColors.chargeYellow,
};

export const isTextEffectEntry = (entry: unknown): entry is TextEffectCF => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (entry as any)?.sys?.contentType?.sys?.id === 'textEffect';
};

export const textEffectRenderer = (entry: TextEffectCF) => {
  if (entry.fields.effectType === 'Rainbow slide (vertical)') {
    return <RainbowSlideVertical entry={entry} />;
  }

  return null;
};
